export const Completer = {
  bindings: {
    title: '@',
    isComplete: '<',
    onToggle: '&',
  },

  template: `
    <div class="completer clearfix"
      ng-class="{ 'complete': $ctrl.isComplete }">
      <div class="completer-action"
        ng-click="$ctrl.onToggle()">
        <span class="completer-state">
          <i class="fa fa-check"></i>
        </span>
        <span class="completer-title text-uppercase">
          {{ $ctrl.title }}
        </span>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Completer/Completer.js